/* eslint-disable */

/**
 * Copyright (c) Grab
 * Grab Design Tokens Project
 * Do not edit directly
 */

// [offsetX] [offsetY] [blur] [spread] [color]
export const gdsDropShadowLevel1North = "0 -4px 8px 0 #0000001a";
export const gdsDropShadowLevel1Northeast = "4px -4px 8px 0 #0000001a";
export const gdsDropShadowLevel1East = "4px 0 8px 0 #0000001a";
export const gdsDropShadowLevel1Southeast = "4px 4px 8px 0 #0000001a";
export const gdsDropShadowLevel1South = "0 4px 8px 0 #0000001a";
export const gdsDropShadowLevel1Southwest = "-4px 4px 8px 0 #0000001a";
export const gdsDropShadowLevel1West = "-4px 0 8px 0 #0000001a";
export const gdsDropShadowLevel1Northwest = "-4px -4px 8px 0 #0000001a";
export const gdsDropShadowLevel2North = "0 -8px 16px 0 #0000001a";
export const gdsDropShadowLevel2Northeast = "8px -8px 16px 0 #0000001a";
export const gdsDropShadowLevel2East = "8px 0 16px 0 #0000001a";
export const gdsDropShadowLevel2Southeast = "8px 8px 16px 0 #0000001a";
export const gdsDropShadowLevel2South = "0 8px 16px 0 #0000001a";
export const gdsDropShadowLevel2Southwest = "-8px 8px 16px 0 #0000001a";
export const gdsDropShadowLevel2West = "-8px 0 16px 0 #0000001a";
export const gdsDropShadowLevel2Northwest = "-8px -8px 16px 0 #0000001a";
export const gdsDropShadowLevel3North = "0 -12px 24px 0 #0000001a";
export const gdsDropShadowLevel3Northeast = "12px -12px 24px 0 #0000001a";
export const gdsDropShadowLevel3East = "12px 0 24px 0 #0000001a";
export const gdsDropShadowLevel3Southeast = "12px 12px 24px 0 #0000001a";
export const gdsDropShadowLevel3South = "0 12px 24px 0 #0000001a";
export const gdsDropShadowLevel3Southwest = "-12px 12px 24px 0 #0000001a";
export const gdsDropShadowLevel3West = "-12px 0 24px 0 #0000001a";
export const gdsDropShadowLevel3Northwest = "-12px -12px 24px 0 #0000001a";
export const gdsDropShadowLevel4North = "0 -16px 32px 0 #0000001a";
export const gdsDropShadowLevel4Northeast = "16px -16px 32px 0 #0000001a";
export const gdsDropShadowLevel4East = "16px 0 32px 0 #0000001a";
export const gdsDropShadowLevel4Southeast = "16px 16px 32px 0 #0000001a";
export const gdsDropShadowLevel4South = "0 16px 32px 0 #0000001a";
export const gdsDropShadowLevel4Southwest = "-16px 16px 32px 0 #0000001a";
export const gdsDropShadowLevel4West = "-16px 0 32px 0 #0000001a";
export const gdsDropShadowLevel4Northwest = "-16px -16px 32px 0 #0000001a";
export const gdsDropShadowLevel5North = "0 -20px 40px 0 #0000001a";
export const gdsDropShadowLevel5Northeast = "20px -20px 40px 0 #0000001a";
export const gdsDropShadowLevel5East = "20px 0 40px 0 #0000001a";
export const gdsDropShadowLevel5Southeast = "20px 20px 40px 0 #0000001a";
export const gdsDropShadowLevel5South = "0 20px 40px 0 #0000001a";
export const gdsDropShadowLevel5Southwest = "-20px 20px 40px 0 #0000001a";
export const gdsDropShadowLevel5West = "-20px 0 40px 0 #0000001a";
export const gdsDropShadowLevel5Northwest = "-20px -20px 40px 0 #0000001a";
export const gdsDropShadowLevel1 = "0 4px 8px 0 #0000001a";
export const gdsDropShadowLevel2Normal = "0 8px 16px 0 #0000001a";
export const gdsDropShadowLevel2Reversed = "0 -8px 16px 0 #0000001a";
export const gdsDropShadowLevel3 = "0 12px 24px 0 #0000001a";
export const gdsDropShadowLevel4 = "0 16px 32px 0 #0000001a";
export const gdsDropShadowLevel5 = "0 20px 40px 0 #0000001a";
